/*
    Custom Slideshow using Flickity to ease the 2 slides per row case
*/
if(!customElements.get('slide-show-banners')){

    class SlideShowBanner extends HTMLElement{
        constructor(){
            super();
            this.slideParent = this.querySelector(".slideshow");
            this.setOptions();            
            window.addEventListener("resize", this.handleWindowResize.bind(this));
            this.enableSlider();
        }

        handleWindowResize(e){
            //check if window is set for at least 500ms
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                console.log("Re-Initing Slider")
                console.log(this.slider);
                this.setOptions();
                this.slider.destroy();
                this.enableSlider();
            }, 500);
        }

        setOptions(){
            this.options = {}
            if(this.dataset.autoplay === "true" && this.hasAttribute("data-speed")){
                this.options.autoPlay = parseInt(this.dataset.speed) * 1000;
            }
            this.options.wrapAround = window.innerWidth > 768 ? (parseInt(this.dataset.slides) > 2) : true
            console.log(this.options);        
        }

        enableSlider(){
            this.slider = new Flickity( this.slideParent, {
                cellAlign: 'left',
                prevNextButtons: false,
                contain: true,
                adaptiveHeight: true,
                ...this.options 
              });
        }

    }


customElements.define("slide-show-banners", SlideShowBanner)
}